(function () {
  'use strict';

  function initCarousel(root) {
    if (!root) return;

    var track = root.querySelector('[data-tc-track]');
    var prevBtn = root.querySelector('[data-tc-prev]');
    var nextBtn = root.querySelector('[data-tc-next]');

    if (!track) return;

    function cardStep() {
      var cards = track.querySelectorAll('.tc-card');
      if (cards.length > 1) {
        var step = cards[1].offsetLeft - cards[0].offsetLeft;
        if (step > 0) return step;
      }
      if (cards.length > 0) {
        return cards[0].getBoundingClientRect().width;
      }
      return track.clientWidth;
    }

    function scrollByAmount(amount) {
      if (typeof track.scrollBy === 'function') {
        track.scrollBy({ left: amount, behavior: 'smooth' });
      } else {
        track.scrollLeft += amount;
      }
    }

    function updateButtons() {
      if (!prevBtn && !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = maxScroll <= 4 || track.scrollLeft >= maxScroll - 4;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByAmount(-cardStep());
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByAmount(cardStep());
      });
    }

    var scrollTicking = false;
    track.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        updateButtons();
        scrollTicking = false;
      });
    });

    window.addEventListener('resize', updateButtons);

    // Images loading after initial paint can change scrollWidth, so
    // recheck once everything has finished loading too.
    window.addEventListener('load', updateButtons);

    updateButtons();
  }

  function init() {
    var carousels = document.querySelectorAll('[data-tc-carousel]');
    carousels.forEach(function (el) {
      initCarousel(el.closest('.tc'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();